<template>
  <div>
    <DevNotes>
      Statistics Component : 40%
      Development Notes
      - แสดงข้อมูลในภาพรวม ของทุกวิชา
        [X] นิสิตในแต่ละวิชามีกี่คน
        [X] นิสิตเข้าใช้งานเวลาไหนมากที่สุด (กราฟ)
      - ดูข้อมูลภาพรวมรายวิชา
        [X] นิสิตที่เรียนในวิชานั้นๆ อยู่หน่วยการเรียนไหนบ้าง (กราฟ)
    </DevNotes>

    <component :is="getCurrentStage().k" :classroomId="classroomId"/> 

  </div>
</template>

<script>
import { getCurrentStage } from "@/developing/dev-data";
import { bulkImportComponent } from "@/developing/utils/modular";

// import ClassroomStatsStoreModule from "@/developing/store/modules/classroom-stats";
// const StoreModule = ClassroomStatsStoreModule;
// const StoreModuleName = "ClassroomStats";

export default {
  components: {
    DevNotes: () => import("@/developing/dev-components/DevNotes"),
    ...bulkImportComponent("components/classroom-stats")
  },
  props: {
    classroomId: {
      type: String,
      default: null
    }
  },
  watch: {
    "classroomId": function (curr, prev) {
      if (curr !== prev) this.$forceUpdate();
    }
  },
  methods: {
    getCurrentStage,
  },
  // beforeCreate() {
  //   if (!this.$store.state.ClassroomStats) this.$store.registerModule(StoreModuleName, StoreModule);
  // },
  // destroyed() {
  //   this.$store.unregisterModule(StoreModuleName);
  // },
}
</script>
